<template>
    <div>
        <!-- DESARROLLLO INICIADO EL MARTES 24-09-2020 ING WUILMER GARCIA-->

        <!-- boton crear -->
        <v-row v-if="componenteEvento.agregar_submodulo">
            <v-col class="d-flex flex-row-reverse">
                <TableButtonComp normalButton @click="addItem" iconBut="fas fa-plus"
                    textButton="Crear Currículo Nacional" />
            </v-col>
            <v-col cols="12">
                <ComundataTablecomp :headers="ConfigCurriculoNacionalHeaders" :items="Datos" :search="search" whitSearch>
                    <template v-slot:situacionValor="{ item }">
                        <v-chip v-if="item.status === 1" small class="color_activo">
                            Activo
                        </v-chip>
                        <v-chip v-if="item.status === 0" small class="mr-2 color_inactivo">
                            Inactivo
                        </v-chip>
                    </template>


                    <template v-slot:action_editar="{ item }">
                        <TableButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
                            tooltipText="Editar Currículo Nacional" />
                    </template>

                    <template v-slot:action_borrar="{ item }">
                        <TableButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)"
                            tooltipText="Borrar Currículo Nacional" deleteButton />
                    </template>
                </ComundataTablecomp>
            </v-col>
        </v-row>
        <!-- fin boton  crear-->

        <!-- /////////////////////////////////////////////////////
             //             PANTALLA PRINCIPAL                  //
             /////////////////////////////////////////////////////    -->

        <!--   
            <v-row class="mx-1 d-flex justify-space-between">
                <v-col cols="12" md="4" class="py-md-0">
                    <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line hide-details ></v-text-field>
                </v-col>
            </v-row>
            -->



        <!-- fin de pantalla principal -->

        <!-- /////////////////////////////////////////////////////
             //     MODAL DE AGREGAR O EDITAR                //
        ////////////////////////////////////////////////////    -->
        <v-form ref="formDatos" lazy-validation>
            <ComunDialogComp v-model="dialog" maxWidth="650" :title="formTitle" @close-modal="dialog = false">
                <template v-slot:body>
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <AutocompleteComp v-model="dataForm.id_ano_lectivo" textLabel="Año lectivo" :items="lectivo"
                                item-value="id" item-text="nom_anolectivo" :isDisable="inhabilitarCampos" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <AutocompleteComp v-model="dataForm.id_mgr_curriculo" textLabel="Currículo Nacional"
                                :items="curriculoNacional" item-value="id" item-text="cod_curriculo"
                                :isDisable="inhabilitarCampos" @change="eventCurriculo" />
                        </v-col>
                        <v-col cols="12" md="12">
                            <textfieldComp v-model="dataForm.nombre_curriculo"
                                textLabel="Nombre del Currículo Nacional del colegio" type="text"
                                :rules="[rul.required, rul.max60]" :readonly="inhabilitarCurriculoDesc" />
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-textarea v-model="dataForm.observacion" label="Observación" rows="4"></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="12">
                            <v-radio-group v-model="dataForm.status" label="Estado :" row>
                                <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                                <v-radio :label="`Inactivo`" :value="0" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <TableButtonComp normalButton @click="saveItem(dataForm.id)" v-if="evento == 'editar'"
                        textButton="Guardar cambios" iconBut="fas fa-save" />
                    <TableButtonComp normalButton v-if="evento == 'agregar'" @click="saveItem" textButton="Guardar"
                        iconBut="fas fa-save" />
                    <TableButtonComp classButton="ml-2" @click="dialog = false" textButton="Cancelar" classColor="red"
                        normalButton />
                </template>
            </ComunDialogComp>

        </v-form>
        <!-- fin de modal agregar o editar perfil -->
        <!--
                <pre>currículo Nacional{{curriculoNacional}}</pre>
                <pre>Datos Listar {{Datos}}</pre>
                <pre>Datos Listar {{Datos}}</pre>            
                <pre>Datos  Formulario {{dataForm}}</pre>            
            -->
    </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import TableButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import { ConfigCurriculoNacionalHeaders } from '../../../../helpers/headersTable';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';

export default {
    name: 'formNotaNum',
    components: {
        ComunDialogComp,
        ComundataTablecomp,
        TableButtonComp,
        AutocompleteComp,
        textfieldComp
    },
    props: ['estadoComp', 'parametros'],


    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 89, "id_modulo": 5 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////

        search: '',
        Datos: [],
        listDatos: [],
        filtro: {},
        ConfigCurriculoNacionalHeaders,

        // MODAL AGREGRAR-EDITAR NOTA NUMERICA
        evento: null,
        titulo: 'Currículo Nacional',
        dialog: false,
        formTitle: '',
        dataForm: {},
        curriculoNacional: [],
        lectivo: [],

        ///////////////////////////////

        inhabilitarCurriculoDesc: false,
        inhabilitarCampos: false,


        // MODAL BORRAR NOTA NUMERICA
        dialog_delete: false,
        desc_delete: null,
        id_delete: null,
        ///////////////////////////////
        editedItem: [],


        //  { text: 'BORRAR', value: 'action_borrar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'},

        //validaciones de formulario
        rul: {
            required: value => !!value || 'Campo requerido',
            inputReq: value => !!value || 'Campo requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo Electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo Electrónico es incorrecto'
                }
            },
        },

    }),


    computed: {
        ...mapGetters('login', ['componenteEvento'])
    },


    watch: {
        // cada vez que la pregunta cambie desde el componente padre, esta función será ejecutada
        estadoComp: function () {

            if (this.estadoComp) {
                this.actualizarParamentro()
                this.loadMain()
            } else {
                //this.limpiarFormUsuario()
            }
        }
    },


    mounted() {
        this.loadMain();

    },

    /*
    created(){
        this.actualizarParamentro()
    },
    */

    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////


        //  ------- MOSTRAR TODOS LOS REGISTROS    --------
        async loadMain() {
            this.limpiarForm()


            try {
                // datos de todos los curriculos creados del colegio de session

                let resp = await axios.get(`administrativo/curriculo/cr/list/${sessionStorage.id_colegio}`)
                this.Datos = resp.data

                if (this.Datos.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No posee curriculo nacional registrado`, tiempo: null })
                }

            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },

        //  ------- seleccionar descripcion de curriculo seleccionado    --------
        async eventCurriculo() {
            // filtrar curriculo seleccionado  
            this.inhabilitarCurriculoDesc = false
            let filtroCurriculo = this.curriculoNacional.filter(item => item.id == this.dataForm.id_mgr_curriculo)
            this.dataForm.nombre_curriculo = filtroCurriculo[0].cod_curriculo


        },


        //  ------- CARGAR LAS CONSULTAS DE LOS FORMULARIOS   --------
        async loadQuery() {

            try {
                // datos de curriculo de clicken1
                let resp = await axios.get(`/administrativo/curriculo/mgr/list/${sessionStorage.id_pais}`)
                this.curriculoNacional = resp.data

                // datos del año lectivo activos del colegio             
                let resp02 = await axios.get(`/administrativo/anoLectivo/estado/${sessionStorage.id_colegio}`)
                this.lectivo = resp02.data
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },

        ////////////////////////////////////////////////////////////
        async limpiarForm() {
            this.dataForm = {
                id_usuario: this.datoLogin.id,
                id_us_ing: this.datoLogin.id,
                id_us_mod: this.datoLogin.id,
                id_colegio: sessionStorage.id_colegio,
                id_ano_lectivo: sessionStorage.id_ano_lectivo,
                id_mgr_curriculo: null,
                nombre_curriculo: null,
                observacion: null,
                status: 1,
            }
            this.resetValidation()

            this.filtro.id_curriculo = null
            this.inhabilitarCampos = false
        },


        // Validar resetear campos al guardar
        resetValidation() {
            this.$refs.formDatos.resetValidation()
        },

        //----------- AREGAR REGISTROS  --------------
        async addItem() {
            this.limpiarForm()
            this.loadQuery()
            this.formTitle = "Crear Currículo Nacional"
            this.dialog = true
            this.evento = 'agregar'
        },


        //--------------EDITAR REGISTRO--------------
        editItem(item) {
            this.limpiarForm()
            this.loadQuery()
            this.formTitle = "Editar Currículo Nacional"
            this.dialog = true
            this.evento = "editar"
            this.inhabilitarCampos = true

            item.id_usuario = this.datoLogin.id
            this.dataForm = Object.assign({}, item)
        },


        // Guardar registro
        async saveItem(id) {

            console.log(this.dataForm);
            if (this.$refs.formDatos.validate()) {

                try {
                    var res = ""
                    if (this.evento == "agregar") {

                        // VALIDAR si existe un curriculo activco del colegio
                        let curriculoActivo = this.Datos.filter(item => item.status == 1)
                        if (curriculoActivo.length == 0) {
                            res = await axios.post("/administrativo/curriculo/", { datosForm: this.dataForm })
                            this.setEnviarMens({ tipo: `${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo: null })
                        } else {
                            this.setEnviarMens({ tipo: `W`, mensaje: `Existe un currículo activo, Debe cerrarlo para crear uno nuevo `, tiempo: 10 })
                        }

                    }

                    if (this.evento == "editar") {
                        res = await axios.put("/administrativo/curriculo/" + id, { datosForm: this.dataForm })
                        this.setEnviarMens({ tipo: `${res.data.messageT}`, mensaje: `Información actualizada`, tiempo: null })

                    }


                    this.loadMain()
                    this.dialog = false
                    this.evento = null
                }

                catch (res) {
                    this.setEnviarMens({ tipo: res.menssageT, mensaje: res.menssage, tiempo: null })
                }
            } else {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe de Ingresar todo los campos requeridos`, tiempo: null })
            }
        },




    },
}
</script>

